import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';

@Injectable()
export class SearchPhoneService {

    private baseUrl: string = '../rest/company/';
    private emergencyPath: string = '/emergency-phone'

    constructor(private http : Http) {}

    getEmergencyPhone(companyOid){
        return this.http
            .get(`${this.baseUrl}${companyOid}${this.emergencyPath}`, { headers: this.getHeaders()})
            .map((res:any) => res.json());
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return myHeaders;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/contact/searchphone.service.ts